'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import {Link} from 'react-router';
import queryString from 'query-string';
import diff from 'object-diff';
import merge from 'lodash/object/merge';
import _cloneDeep from 'lodash/lang/cloneDeep';
import { removeFromPipedQuery } from 'utils/strings';
import fallbackConfig from '../../fallbackConfig';

var MediaFilterCategory = React.createClass({

    displayName: 'MediaFilterCategory',

    mixins: [],

    propTypes: {
        filter: React.PropTypes.object,
        query: React.PropTypes.object,
        ix: React.PropTypes.number
    },

    prepareLinkParams( sfilter, pfilter ) {
        var query       = _cloneDeep( this.props.query );
        var linkParams  = queryString.parse( sfilter.params );
        var filterKey   = Object.keys( linkParams ).pop();

        linkParams.per_page = this.getPerPageParam();

        /**
         * if the filter is active, remove filter value from query
         * and remove query values from child filters as well
         */
        if ( sfilter.active ) {
            var filterQuery = query;

            sfilter.children.length && sfilter.children.filter( cfilter => !!cfilter.active ).forEach( cfilter => {
                var cfilterParams = queryString.parse( cfilter.params );
                filterQuery = removeFromPipedQuery( cfilterParams, filterQuery );
                filterQuery = diff( cfilterParams, filterQuery );
            });

            filterQuery = removeFromPipedQuery( linkParams, filterQuery );
            filterQuery = diff( linkParams, filterQuery );
            if ( pfilter ) {
                var pQuery = queryString.parse( pfilter.params );
                filterQuery = merge( filterQuery, pQuery );
            }

            linkParams = filterQuery;
        /**
         * otherwise add this value to the params
         */
        } else {
            if ( query[filterKey] ) {
                linkParams[filterKey] += '|' + query[filterKey];
            }
            linkParams = merge(query, linkParams);
        }

        return linkParams;
    },

    getPerPageParam() {
        // get it from store, if it is used in this session
        if (store.get('pagination_amount')) {
            return store.get('pagination_amount');
        }
        // get it from config
        const { defaultPerPageResults } = flux.getStore('app').getState().config.toJS();

        if (Number.isInteger(defaultPerPageResults)) {
            return defaultPerPageResults;
        }
        return fallbackConfig.defaultPerPageResults;
    },

    renderFilterMenu() {
        if ( this.props.filter.get('active') ) {
            return (this.renderFilterList(this.props.filter.get('children').toJS(), true));
        }
    },

    renderFilterList(children, firstLevel = false) {
        return (
            <ul className={`category__list ${firstLevel ? 'first-level': ''}`}>
                {children.map( (child) => {
                    return this.checkFilterElement(child);
                })}
            </ul>
        );
    },

    checkFilterElement(child) {
        if ( child.hidden ) {
            return null;
        }
        let linkParams = this.prepareLinkParams( child );
        delete linkParams.page;
        return (this.renderFilterElement(child, linkParams));
    },

    renderFilterElement(child, linkParams) {
        return (
            <li key={child.value}>
                <Link
                    className={ child.active ? 'active' : '' }
                    onClick={flux.getActions('media').closeFilters}
                    to="listing"
                    query={linkParams}>
                    {child.name} ({child.count})
                    {child.active ? <span className="list__clear close" /> : ''}
                </Link>
                {(() => {
                    if ( child.children.length ) {
                        return this.renderFilterList(child.children);
                    }
                })()}
            </li>
        );
    },

    toggleFilter(e) {
        e.preventDefault();
        flux.getActions('media').toggleFilter(this.props.ix);
    },

    render() {
        return (
            <div className="filters__category">
                <a href="#" onClick={this.toggleFilter} className="category__header">
                    {this.props.filter.get('name')}
                    <i className={this.props.filter.get('active') ? 'minus-small' : 'plus-small'} />
                </a>
                {this.renderFilterMenu()}
            </div>
        );
    }
});

module.exports = MediaFilterCategory;



// WEBPACK FOOTER //
// ./app/pages/media/mediaFilterCategory.jsx